import { Controller } from '@hotwired/stimulus';

// Closes the per-invoice edit modal on the MOE-fee show page after a
// successful Turbo Stream save. Wired exclusively via the form's
// `data-action="turbo:submit-end->moe-fee-invoice-edit#onSubmitEnd"` —
// no manual addEventListener in connect() (which would fire the handler
// twice and re-dispatch `modal:close` to every external listener).
//
// On 2xx, walks up to the parent edit modal and calls its modal
// controller's close() method. On 4xx, the server replaces the form
// wrapper with a fresh render carrying inline field errors — the modal
// stays open with the user's input and the errors in place.
//
// @example
//   <%= form_with model: invoice, url: update_path, method: :patch,
//                 data: {
//                   controller: "moe-fee-invoice-edit",
//                   action: "turbo:submit-end->moe-fee-invoice-edit#onSubmitEnd"
//                 } do |form| %>
export default class extends Controller {
  onSubmitEnd(event) {
    if (!event.detail?.success) return;

    const modal = this.element.closest('[id^="moe-fee-invoice-edit-modal-"]');
    modal?.modalController?.close();
  }
}
